import React from 'react'
import { Link } from 'react-router-dom';
import { SVGIcons, ImgIcons } from "../../Helpers/Common";

var SVGIcon = "";
var ImageData = "";

SVGIcons().then((resultData) => (SVGIcon = resultData));
ImgIcons().then((result) => (ImageData = result));

const FooterEth = () => {
    return (
        <div className="Eth-Footer">
            <div className="eth-content1">
                <li>
                    <Link to="/terms">Terms & Conditions</Link>
                </li>
                <div className="line1">|</div>
                <li>
                    <Link to="/privacy">Privacy Policy</Link>
                </li>
            </div>
            <div className="eth-content2">
                {/* <ul className="social"> */}
                <li>
                    {" "}
                    <a
                        href="https://www.facebook.com/ethiotelecom/"
                        target="_blank"
                    >
                        <img src={SVGIcon["icons8-facebook.svg"]} alt="fb" />
                    </a>{" "}
                </li>
                <li>
                    {" "}
                    <a
                        href="https://www.youtube.com/c/EthiotelecomETH/"
                        target="_blank"
                    >
                        <img src={SVGIcon["icons8-youtube.svg"]} alt="You Tube" />
                    </a>{" "}
                </li>
                <li>
                    {" "}
                    <a
                        href="https://www.instagram.com/ethiotelecom/"
                        target="_blank"
                    >
                        <img src={SVGIcon["icons8-instagram.svg"]} alt="Insta" />
                    </a>{" "}
                </li>

                <li>
                    {" "}
                    <a
                        href="https://www.linkedin.com/company/ethio-telecom/"
                        target="_blank"
                    >
                        <img src={SVGIcon["icons8-linkedin.svg"]} alt="In" />
                    </a>{" "}
                </li>
                <li>
                    {" "}
                    <a href="https://twitter.com/ethiotelecom/" target="_blank">
                        <img src={SVGIcon["icons8-twitterx.svg"]} alt="Tw" />
                    </a>{" "}
                </li>
                {/* </ul> */}
            </div>
            <div className="eth-content3">
                <p> &copy; {new Date().getFullYear()} Ethio telecom All Rights Reserved.</p>
            </div>

        </div>
    )
}

export default FooterEth;